module.exports = __webpack_public_path__ + "static/media/user.5d2f8d94.svg";